module.exports = __webpack_public_path__ + "img/book.43db9982.png";